export default __webpack_public_path__ + "static/media/background_1_large.27cf3c57.jpg";